<div class="duna-customers-container">
  <!-- ── Header ─────────────────────────────────────────────────── -->
  <mat-card class="header-card">
    <mat-card-header>
      <mat-card-title><h1>Kundedatabase</h1></mat-card-title>
      <mat-card-subtitle>
        Administrer kunder, og se ubehandlede indtægtsgivende events tilknyttet
        dem.
      </mat-card-subtitle>
    </mat-card-header>
  </mat-card>

  <!-- ── Sektion 1: Kundeoversigt ───────────────────────────────── -->
  <mat-card class="table-card">
    <div class="card-header-with-action">
      <div class="card-header-text">
        <span class="card-title">Kunder</span>
        <span class="card-subtitle"
          >Søg og administrer eksisterende kunder</span
        >
      </div>
      <div class="header-actions">
        <button mat-stroked-button (click)="openImportDialog()">
          <mat-icon>upload_file</mat-icon>
          Importer CSV
        </button>
        <button mat-raised-button color="primary" (click)="openCreateDialog()">
          <mat-icon>add</mat-icon>
          Tilføj kunde
        </button>
      </div>
    </div>
    <mat-card-content>
      <app-dynamic-table
        #customersTable
        [dynamicInput]="{
          dataSource: { type: 'text', value: 'duna_customers' }
        }"
      ></app-dynamic-table>
    </mat-card-content>
  </mat-card>

  <!-- ── Sektion 2: Fakturering ─────────────────────────────────── -->
  <mat-card class="table-card" #billingSection>
    <div class="card-header-with-action">
      <div class="card-header-text">
        <span class="card-title">Fakturering</span>
        <span class="card-subtitle"
          >Indtægtsgivende events med tilknyttet kunde – marker som behandlet
          når de er faktureret</span
        >
      </div>
      @if (selectedCustomer) {
      <mat-chip-set>
        <mat-chip highlighted color="primary" (removed)="clearCustomerFilter()">
          <mat-icon matChipAvatar>person</mat-icon>
          {{ selectedCustomer.name }}
          <button matChipRemove>
            <mat-icon>cancel</mat-icon>
          </button>
        </mat-chip>
      </mat-chip-set>
      }
    </div>
    <mat-card-content>
      <app-dynamic-table
        #billingTable
        [dynamicInput]="{
          dataSource: { type: 'text', value: 'duna_customer_events' }
        }"
      ></app-dynamic-table>
    </mat-card-content>
  </mat-card>
</div>
